export enum ATHStatusEnum {
  'Imported' = 1,
  'Exported QmAdmin',
  'Imported QmAdmin',
  'Processed',
  'Transaction Linked',
  'Transaction Exported',
  'Rejection Linked',
  'Rejection Exported',
  'Completed',
  'Cancelled',
  'Manually Processed',
  'Imported SP Fees',
  'Busy Importing'
}

export namespace ATHStatusEnum {
  export function values() {
    return Object.keys(ATHStatusEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
